// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * Status contains a list of message statuses.
 * Statuses mostly represent the status of a message as it journeys
 * through being sent or received.
 * It should be noted that for outbound statuses we do not always
 * know if a message was actually delivered to a person. This is
 * because carriers will:
 * - Sometimes block or mark a message as SPAM without telling us.
 * - A handset may not have reception when the carrier tries to deliver a
 * message.
 * - A handset may be turned off when the carrier tries to deliver.
 * In the above cases the carrier may still indicate the message was delivered
 * (even though it wasn't) or simply indicate the message was sent
 * (without indicating it was delivered).
 * A "read" status is not an indication the end user actually read the
 * message. We don't actually know if the message was read by the end user.
 * Therefore a "read" status indicates a Weave user has read the message.
 * A status of "not sent" indicates the message was not sent to a provider
 * because:
 * - The person has opted out of SMS messages.
 * - The person number is invalid (not a complete number).
 * - The person number is not SMS enabled.
 * - The SMS platform experienced an unexpected error within Weave preventing it
 * from sending.
 * An "error" status indicates an error sending the message such as a
 * network error.
 * In the event the status is "not sent" or "error" the "StatusDetails"
 * SMS field can be examined for more information regarding the nature
 * of the error or why the message was not sent.
 */
export var Status;
(function (Status) {
    Status["STATUS_UNSPECIFIED"] = "STATUS_UNSPECIFIED";
    Status["STATUS_NEW"] = "STATUS_NEW";
    Status["STATUS_SENT"] = "STATUS_SENT";
    Status["STATUS_NOT_SENT"] = "STATUS_NOT_SENT";
    Status["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    Status["STATUS_RECEIVED"] = "STATUS_RECEIVED";
    Status["STATUS_READ"] = "STATUS_READ";
    Status["STATUS_ERROR"] = "STATUS_ERROR";
})(Status || (Status = {}));
export var Status_index;
(function (Status_index) {
    Status_index[Status_index["STATUS_UNSPECIFIED"] = 0] = "STATUS_UNSPECIFIED";
    Status_index[Status_index["STATUS_NEW"] = 1] = "STATUS_NEW";
    Status_index[Status_index["STATUS_SENT"] = 2] = "STATUS_SENT";
    Status_index[Status_index["STATUS_NOT_SENT"] = 3] = "STATUS_NOT_SENT";
    Status_index[Status_index["STATUS_DELIVERED"] = 4] = "STATUS_DELIVERED";
    Status_index[Status_index["STATUS_RECEIVED"] = 5] = "STATUS_RECEIVED";
    Status_index[Status_index["STATUS_READ"] = 6] = "STATUS_READ";
    Status_index[Status_index["STATUS_ERROR"] = 7] = "STATUS_ERROR";
})(Status_index || (Status_index = {}));
/**
 * Direction indicates if the message was sent from Weave to a person
 * phone number (outbound) or received from a person phone number
 * (inbound).
 */
export var Direction;
(function (Direction) {
    Direction["DIRECTION_UNSPECIFIED"] = "DIRECTION_UNSPECIFIED";
    Direction["DIRECTION_OUTBOUND"] = "DIRECTION_OUTBOUND";
    Direction["DIRECTION_INBOUND"] = "DIRECTION_INBOUND";
})(Direction || (Direction = {}));
export var Direction_index;
(function (Direction_index) {
    Direction_index[Direction_index["DIRECTION_UNSPECIFIED"] = 0] = "DIRECTION_UNSPECIFIED";
    Direction_index[Direction_index["DIRECTION_OUTBOUND"] = 1] = "DIRECTION_OUTBOUND";
    Direction_index[Direction_index["DIRECTION_INBOUND"] = 2] = "DIRECTION_INBOUND";
})(Direction_index || (Direction_index = {}));
/**
 * Encoding indicates how the message was encoded by the sending provider.
 * Most messages are sent over GSM7 which allows 160 characters for single
 * segment messages and 153 characters per segment for multi-segment messages.
 * UCS2 encoding is used to express a wider range of characters such Chinese
 * characters, angled quotes, and emojis. Messages encoded as UCS2 are limited
 * to 70 characters for single segments and 67 characters for multi-segment
 * messages.
 */
export var Encoding;
(function (Encoding) {
    Encoding["ENCODING_UNSPECIFIED"] = "ENCODING_UNSPECIFIED";
    Encoding["ENCODING_GSM7"] = "ENCODING_GSM7";
    Encoding["ENCODING_UCS2"] = "ENCODING_UCS2";
    Encoding["ENCODING_MMS"] = "ENCODING_MMS";
})(Encoding || (Encoding = {}));
export var Encoding_index;
(function (Encoding_index) {
    Encoding_index[Encoding_index["ENCODING_UNSPECIFIED"] = 0] = "ENCODING_UNSPECIFIED";
    Encoding_index[Encoding_index["ENCODING_GSM7"] = 1] = "ENCODING_GSM7";
    Encoding_index[Encoding_index["ENCODING_UCS2"] = 2] = "ENCODING_UCS2";
    Encoding_index[Encoding_index["ENCODING_MMS"] = 3] = "ENCODING_MMS";
})(Encoding_index || (Encoding_index = {}));
/**
 * RelatedType is a list of registered related id types. Additional
 * types may be added by contacting the team in charge of the SMS
 * platform.
 */
export var RelatedType;
(function (RelatedType) {
    RelatedType["RELATED_TYPE_UNSPECIFIED"] = "RELATED_TYPE_UNSPECIFIED";
    RelatedType["RELATED_TYPE_APPOINTMENT"] = "RELATED_TYPE_APPOINTMENT";
    RelatedType["RELATED_TYPE_ORDER"] = "RELATED_TYPE_ORDER";
    RelatedType["RELATED_TYPE_RECALL"] = "RELATED_TYPE_RECALL";
    RelatedType["RELATED_TYPE_PERSON"] = "RELATED_TYPE_PERSON";
    RelatedType["RELATED_TYPE_MEDIA"] = "RELATED_TYPE_MEDIA";
    RelatedType["RELATED_TYPE_GROUP_QUICK_FILL"] = "RELATED_TYPE_GROUP_QUICK_FILL";
    RelatedType["RELATED_TYPE_GROUP_SCHEDULE"] = "RELATED_TYPE_GROUP_SCHEDULE";
    RelatedType["RELATED_TYPE_REVIEW"] = "RELATED_TYPE_REVIEW";
    RelatedType["RELATED_TYPE_MISSED_CALL"] = "RELATED_TYPE_MISSED_CALL";
    RelatedType["RELATED_TYPE_BIRTHDAY"] = "RELATED_TYPE_BIRTHDAY";
    RelatedType["RELATED_TYPE_ONLINE_SCHEDULE_REQUEST"] = "RELATED_TYPE_ONLINE_SCHEDULE_REQUEST";
    RelatedType["RELATED_TYPE_MMS_CONSENT_REQUEST"] = "RELATED_TYPE_MMS_CONSENT_REQUEST";
    RelatedType["RELATED_TYPE_SOURCE_SYSTEM"] = "RELATED_TYPE_SOURCE_SYSTEM";
    RelatedType["RELATED_TYPE_BULK_MESSAGE"] = "RELATED_TYPE_BULK_MESSAGE";
    RelatedType["RELATED_TYPE_SMS_WRITEBACK_NOTE"] = "RELATED_TYPE_SMS_WRITEBACK_NOTE";
    RelatedType["RELATED_TYPE_SMS_WRITEBACK_NOTE_PMS"] = "RELATED_TYPE_SMS_WRITEBACK_NOTE_PMS";
    RelatedType["RELATED_TYPE_SAVE_THE_DATE"] = "RELATED_TYPE_SAVE_THE_DATE";
    RelatedType["RELATED_TYPE_EXTERNAL_MESSAGE_ID"] = "RELATED_TYPE_EXTERNAL_MESSAGE_ID";
    RelatedType["RELATED_TYPE_AMP_MESSAGE_ID"] = "RELATED_TYPE_AMP_MESSAGE_ID";
    RelatedType["RELATED_TYPE_SCHEDULED_MESSAGE_ID"] = "RELATED_TYPE_SCHEDULED_MESSAGE_ID";
    RelatedType["RELATED_TYPE_MISSED_TEXT"] = "RELATED_TYPE_MISSED_TEXT";
    RelatedType["RELATED_TYPE_FORM"] = "RELATED_TYPE_FORM";
    RelatedType["RELATED_TYPE_TEXT_TO_PAY"] = "RELATED_TYPE_TEXT_TO_PAY";
    RelatedType["RELATED_TYPE_INVOICE"] = "RELATED_TYPE_INVOICE";
    RelatedType["RELATED_TYPE_PAY_OVER_TIME"] = "RELATED_TYPE_PAY_OVER_TIME";
    RelatedType["RELATED_TYPE_TREATMENT_PLAN"] = "RELATED_TYPE_TREATMENT_PLAN";
})(RelatedType || (RelatedType = {}));
export var RelatedType_index;
(function (RelatedType_index) {
    RelatedType_index[RelatedType_index["RELATED_TYPE_UNSPECIFIED"] = 0] = "RELATED_TYPE_UNSPECIFIED";
    RelatedType_index[RelatedType_index["RELATED_TYPE_APPOINTMENT"] = 1] = "RELATED_TYPE_APPOINTMENT";
    RelatedType_index[RelatedType_index["RELATED_TYPE_ORDER"] = 2] = "RELATED_TYPE_ORDER";
    RelatedType_index[RelatedType_index["RELATED_TYPE_RECALL"] = 3] = "RELATED_TYPE_RECALL";
    RelatedType_index[RelatedType_index["RELATED_TYPE_PERSON"] = 4] = "RELATED_TYPE_PERSON";
    RelatedType_index[RelatedType_index["RELATED_TYPE_MEDIA"] = 5] = "RELATED_TYPE_MEDIA";
    RelatedType_index[RelatedType_index["RELATED_TYPE_GROUP_QUICK_FILL"] = 6] = "RELATED_TYPE_GROUP_QUICK_FILL";
    RelatedType_index[RelatedType_index["RELATED_TYPE_GROUP_SCHEDULE"] = 7] = "RELATED_TYPE_GROUP_SCHEDULE";
    RelatedType_index[RelatedType_index["RELATED_TYPE_REVIEW"] = 8] = "RELATED_TYPE_REVIEW";
    RelatedType_index[RelatedType_index["RELATED_TYPE_MISSED_CALL"] = 9] = "RELATED_TYPE_MISSED_CALL";
    RelatedType_index[RelatedType_index["RELATED_TYPE_BIRTHDAY"] = 10] = "RELATED_TYPE_BIRTHDAY";
    RelatedType_index[RelatedType_index["RELATED_TYPE_ONLINE_SCHEDULE_REQUEST"] = 11] = "RELATED_TYPE_ONLINE_SCHEDULE_REQUEST";
    RelatedType_index[RelatedType_index["RELATED_TYPE_MMS_CONSENT_REQUEST"] = 12] = "RELATED_TYPE_MMS_CONSENT_REQUEST";
    RelatedType_index[RelatedType_index["RELATED_TYPE_SOURCE_SYSTEM"] = 13] = "RELATED_TYPE_SOURCE_SYSTEM";
    RelatedType_index[RelatedType_index["RELATED_TYPE_BULK_MESSAGE"] = 14] = "RELATED_TYPE_BULK_MESSAGE";
    RelatedType_index[RelatedType_index["RELATED_TYPE_SMS_WRITEBACK_NOTE"] = 15] = "RELATED_TYPE_SMS_WRITEBACK_NOTE";
    RelatedType_index[RelatedType_index["RELATED_TYPE_SMS_WRITEBACK_NOTE_PMS"] = 16] = "RELATED_TYPE_SMS_WRITEBACK_NOTE_PMS";
    RelatedType_index[RelatedType_index["RELATED_TYPE_SAVE_THE_DATE"] = 17] = "RELATED_TYPE_SAVE_THE_DATE";
    RelatedType_index[RelatedType_index["RELATED_TYPE_EXTERNAL_MESSAGE_ID"] = 18] = "RELATED_TYPE_EXTERNAL_MESSAGE_ID";
    RelatedType_index[RelatedType_index["RELATED_TYPE_AMP_MESSAGE_ID"] = 19] = "RELATED_TYPE_AMP_MESSAGE_ID";
    RelatedType_index[RelatedType_index["RELATED_TYPE_SCHEDULED_MESSAGE_ID"] = 20] = "RELATED_TYPE_SCHEDULED_MESSAGE_ID";
    RelatedType_index[RelatedType_index["RELATED_TYPE_MISSED_TEXT"] = 21] = "RELATED_TYPE_MISSED_TEXT";
    RelatedType_index[RelatedType_index["RELATED_TYPE_FORM"] = 22] = "RELATED_TYPE_FORM";
    RelatedType_index[RelatedType_index["RELATED_TYPE_TEXT_TO_PAY"] = 23] = "RELATED_TYPE_TEXT_TO_PAY";
    RelatedType_index[RelatedType_index["RELATED_TYPE_INVOICE"] = 24] = "RELATED_TYPE_INVOICE";
    RelatedType_index[RelatedType_index["RELATED_TYPE_PAY_OVER_TIME"] = 25] = "RELATED_TYPE_PAY_OVER_TIME";
    RelatedType_index[RelatedType_index["RELATED_TYPE_TREATMENT_PLAN"] = 26] = "RELATED_TYPE_TREATMENT_PLAN";
})(RelatedType_index || (RelatedType_index = {}));
/**
 * Bool enum type allows the bool value to remain unspecified. Basically, it's a
 * nullable bool value.
 */
export var Bool;
(function (Bool) {
    Bool["BOOL_UNSPECIFIED"] = "BOOL_UNSPECIFIED";
    Bool["BOOL_TRUE"] = "BOOL_TRUE";
    Bool["BOOL_FALSE"] = "BOOL_FALSE";
})(Bool || (Bool = {}));
export var Bool_index;
(function (Bool_index) {
    Bool_index[Bool_index["BOOL_UNSPECIFIED"] = 0] = "BOOL_UNSPECIFIED";
    Bool_index[Bool_index["BOOL_TRUE"] = 1] = "BOOL_TRUE";
    Bool_index[Bool_index["BOOL_FALSE"] = 2] = "BOOL_FALSE";
})(Bool_index || (Bool_index = {}));
/**
 * Provider relates information regarding the downstream Weave SMS
 * partner to whom the message is sent or from whom the message is
 * received.
 * The Weave number is registered with one of these providers.
 */
export var Provider;
(function (Provider) {
    Provider["PROVIDER_UNSPECIFIED"] = "PROVIDER_UNSPECIFIED";
    Provider["PROVIDER_TWILIO"] = "PROVIDER_TWILIO";
    Provider["PROVIDER_BANDWIDTH"] = "PROVIDER_BANDWIDTH";
    Provider["PROVIDER_TELNYX"] = "PROVIDER_TELNYX";
    Provider["PROVIDER_FLOWROUTE"] = "PROVIDER_FLOWROUTE";
    Provider["PROVIDER_WEAVE"] = "PROVIDER_WEAVE";
    Provider["PROVIDER_MOCK"] = "PROVIDER_MOCK";
})(Provider || (Provider = {}));
export var Provider_index;
(function (Provider_index) {
    Provider_index[Provider_index["PROVIDER_UNSPECIFIED"] = 0] = "PROVIDER_UNSPECIFIED";
    Provider_index[Provider_index["PROVIDER_TWILIO"] = 1] = "PROVIDER_TWILIO";
    Provider_index[Provider_index["PROVIDER_BANDWIDTH"] = 2] = "PROVIDER_BANDWIDTH";
    Provider_index[Provider_index["PROVIDER_TELNYX"] = 3] = "PROVIDER_TELNYX";
    Provider_index[Provider_index["PROVIDER_FLOWROUTE"] = 4] = "PROVIDER_FLOWROUTE";
    Provider_index[Provider_index["PROVIDER_WEAVE"] = 5] = "PROVIDER_WEAVE";
    Provider_index[Provider_index["PROVIDER_MOCK"] = 6] = "PROVIDER_MOCK";
})(Provider_index || (Provider_index = {}));
/**
 * Carrier refers to a wireless communications service provider that operates
 * and owns its own wireless network.
 * The ones listed explicitly here are the only four in the United States.
 */
export var Carrier;
(function (Carrier) {
    Carrier["CARRIER_UNSPECIFIED"] = "CARRIER_UNSPECIFIED";
    Carrier["CARRIER_OTHER"] = "CARRIER_OTHER";
    Carrier["CARRIER_VERIZON"] = "CARRIER_VERIZON";
    Carrier["CARRIER_ATT"] = "CARRIER_ATT";
    Carrier["CARRIER_TMOBILE"] = "CARRIER_TMOBILE";
    Carrier["CARRIER_US_CELLULAR"] = "CARRIER_US_CELLULAR";
})(Carrier || (Carrier = {}));
export var Carrier_index;
(function (Carrier_index) {
    Carrier_index[Carrier_index["CARRIER_UNSPECIFIED"] = 0] = "CARRIER_UNSPECIFIED";
    Carrier_index[Carrier_index["CARRIER_OTHER"] = 1] = "CARRIER_OTHER";
    Carrier_index[Carrier_index["CARRIER_VERIZON"] = 2] = "CARRIER_VERIZON";
    Carrier_index[Carrier_index["CARRIER_ATT"] = 3] = "CARRIER_ATT";
    Carrier_index[Carrier_index["CARRIER_TMOBILE"] = 4] = "CARRIER_TMOBILE";
    Carrier_index[Carrier_index["CARRIER_US_CELLULAR"] = 8] = "CARRIER_US_CELLULAR";
})(Carrier_index || (Carrier_index = {}));
/**
 * ThreadStatus indicates the status of a thread.
 */
export var ThreadStatus;
(function (ThreadStatus) {
    ThreadStatus["THREAD_STATUS_UNSPECIFIED"] = "THREAD_STATUS_UNSPECIFIED";
    ThreadStatus["NEW"] = "NEW";
    ThreadStatus["ACTIVE"] = "ACTIVE";
    ThreadStatus["ARCHIVED"] = "ARCHIVED";
})(ThreadStatus || (ThreadStatus = {}));
export var ThreadStatus_index;
(function (ThreadStatus_index) {
    ThreadStatus_index[ThreadStatus_index["THREAD_STATUS_UNSPECIFIED"] = 0] = "THREAD_STATUS_UNSPECIFIED";
    ThreadStatus_index[ThreadStatus_index["NEW"] = 1] = "NEW";
    ThreadStatus_index[ThreadStatus_index["ACTIVE"] = 2] = "ACTIVE";
    ThreadStatus_index[ThreadStatus_index["ARCHIVED"] = 3] = "ARCHIVED";
})(ThreadStatus_index || (ThreadStatus_index = {}));
export var WeaveSMSType_Enum;
(function (WeaveSMSType_Enum) {
    WeaveSMSType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    WeaveSMSType_Enum["VOICEMAIL_NOTIFICATION"] = "VOICEMAIL_NOTIFICATION";
    WeaveSMSType_Enum["PASSWORD_RESET"] = "PASSWORD_RESET";
    WeaveSMSType_Enum["OTP"] = "OTP";
    WeaveSMSType_Enum["MOBILE_NUMBER_VERIFICATION"] = "MOBILE_NUMBER_VERIFICATION";
    WeaveSMSType_Enum["PAYOUT_INFO_UPDATE"] = "PAYOUT_INFO_UPDATE";
    WeaveSMSType_Enum["MOBILE_DOWNLOAD_LINK"] = "MOBILE_DOWNLOAD_LINK";
    WeaveSMSType_Enum["ONBOARDING_SELF_SIGNUP"] = "ONBOARDING_SELF_SIGNUP";
})(WeaveSMSType_Enum || (WeaveSMSType_Enum = {}));
export var WeaveSMSType_Enum_index;
(function (WeaveSMSType_Enum_index) {
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["VOICEMAIL_NOTIFICATION"] = 1] = "VOICEMAIL_NOTIFICATION";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["PASSWORD_RESET"] = 2] = "PASSWORD_RESET";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["OTP"] = 3] = "OTP";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["MOBILE_NUMBER_VERIFICATION"] = 4] = "MOBILE_NUMBER_VERIFICATION";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["PAYOUT_INFO_UPDATE"] = 5] = "PAYOUT_INFO_UPDATE";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["MOBILE_DOWNLOAD_LINK"] = 6] = "MOBILE_DOWNLOAD_LINK";
    WeaveSMSType_Enum_index[WeaveSMSType_Enum_index["ONBOARDING_SELF_SIGNUP"] = 7] = "ONBOARDING_SELF_SIGNUP";
})(WeaveSMSType_Enum_index || (WeaveSMSType_Enum_index = {}));
export var InboundSmsClassification_Enum;
(function (InboundSmsClassification_Enum) {
    InboundSmsClassification_Enum["INVALID"] = "INVALID";
    InboundSmsClassification_Enum["CONFIRMATION"] = "CONFIRMATION";
    InboundSmsClassification_Enum["CANCELATION"] = "CANCELATION";
})(InboundSmsClassification_Enum || (InboundSmsClassification_Enum = {}));
export var InboundSmsClassification_Enum_index;
(function (InboundSmsClassification_Enum_index) {
    InboundSmsClassification_Enum_index[InboundSmsClassification_Enum_index["INVALID"] = 0] = "INVALID";
    InboundSmsClassification_Enum_index[InboundSmsClassification_Enum_index["CONFIRMATION"] = 1] = "CONFIRMATION";
    InboundSmsClassification_Enum_index[InboundSmsClassification_Enum_index["CANCELATION"] = 2] = "CANCELATION";
})(InboundSmsClassification_Enum_index || (InboundSmsClassification_Enum_index = {}));
